module.exports = __webpack_public_path__ + "media/images/about__how-we-make-money--horizontal-406fabd9a86f98c6f9fb2f919b6675e7.jpg";